// generated by genversion
export var version = '5.1.9';
//# sourceMappingURL=version.js.map